import { render, staticRenderFns } from "./CalendarBlank.vue?vue&type=template&id=0bf2dcbd"
import script from "./CalendarBlank.vue?vue&type=script&lang=js"
export * from "./CalendarBlank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports